import { ProposalQuoteSection, SupplierQuote } from "../../types/proposalDocuments.types";

export const getSectionAnchorId = (sectionIndex: number | string) =>
  `quote-section-${String(sectionIndex)}`;

export const getQuoteAnchorId = (sectionIndex: number | string, quoteIndex: number) =>
  `proposed-${String(sectionIndex)}-${quoteIndex.toString()}`;

export const getSectionDisplayTitle = (section: ProposalQuoteSection) =>
  [section.supplier, section.product].filter(Boolean).join(" — ") || "Untitled Section";

export const getQuoteSummary = (quote: SupplierQuote): string[] => {
  const meterType = quote.mprn ? "mprn" : "mpan";
  const meterNumber = meterType === "mpan" ? quote.mpan : quote.mprn;

  return [
    meterNumber ? `${meterType.toUpperCase()} ${meterNumber}` : null,
    quote.estimated_annual_cost ? `£${quote.estimated_annual_cost.toFixed(2)}/yr` : null,
  ].filter((v): v is string => Boolean(v));
};
